export const step9 = {
  changeTaxConsultingYn(yOrN: 'Y' | 'N') {
    this.userInput.taxConsultingYn = yOrN;
    this.moveNext();
  },
};
